import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(props, _ref) {
    var $f7, $, $f7router, $f7route, $on, $update, user, avatar, images, qrcodes, vw, vh, syncImages, syncQRCodes, images_, imageError, getImage, search, clearSearch, addItem, rotateImage, addImageFormCamera, video, canvas, stream, showCamera, saveCamera, stopCamera, addImageFromGallery, addImage, addTag, addDocument, getFileBrowser, addQRCode, scanQRCode, myPrompt, clickOnQRCode, toggleMedicalRecords, share, shareViaWA1, shareViaWA, renameQRCode, clickOnPhoto, clickOnDocument;
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            $f7 = _ref.$f7, $ = _ref.$, $f7router = _ref.$f7router, $f7route = _ref.$f7route, $on = _ref.$on, $update = _ref.$update;

            if (!myApp.children) {
              _context25.next = 7;
              break;
            }

            _context25.next = 4;
            return myApp.getChildren();

          case 4:
            _context25.t0 = _context25.sent;
            _context25.next = 10;
            break;

          case 7:
            _context25.next = 9;
            return myApp.user();

          case 9:
            _context25.t0 = _context25.sent;

          case 10:
            user = _context25.t0;
            user.data = user.data || {};
            user.data.medical = user.data.medical || {};
            user.data.medical.images = user.data.medical.images || [];
            user.data.medical.images_tags = user.data.medical.images_tags || _toConsumableArray(Array(user.data.medical.images.length));
            user.data.medical.documents = user.data.medical.documents || [];
            user.data.medical.qrcodes = user.data.medical.qrcodes || [];
            _context25.next = 19;
            return myStorage.get(user.data.avatar);

          case 19:
            _context25.t1 = _context25.sent;

            if (_context25.t1) {
              _context25.next = 22;
              break;
            }

            _context25.t1 = user.data.avatar;

          case 22:
            avatar = _context25.t1;
            images = [], qrcodes = [];
            vw = window.innerWidth, vh = window.innerHeight;

            syncImages = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        user.data.medical.images.map( /*#__PURE__*/function () {
                          var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item) {
                            var newItem;
                            return _regeneratorRuntime.wrap(function _callee$(_context) {
                              while (1) {
                                switch (_context.prev = _context.next) {
                                  case 0:
                                    newItem = _objectSpread({}, item);
                                    _context.next = 3;
                                    return myStorage.get(item.src);

                                  case 3:
                                    _context.t0 = _context.sent;

                                    if (_context.t0) {
                                      _context.next = 6;
                                      break;
                                    }

                                    _context.t0 = item.src;

                                  case 6:
                                    newItem.src = _context.t0;
                                    images.push(newItem);

                                  case 8:
                                  case "end":
                                    return _context.stop();
                                }
                              }
                            }, _callee);
                          }));

                          return function (_x3) {
                            return _ref4.apply(this, arguments);
                          };
                        }());

                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function syncImages() {
                return _ref3.apply(this, arguments);
              };
            }();

            syncQRCodes = /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        user.data.medical.qrcodes.map( /*#__PURE__*/function () {
                          var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(item) {
                            var newItem;
                            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                              while (1) {
                                switch (_context3.prev = _context3.next) {
                                  case 0:
                                    newItem = _objectSpread({}, item);
                                    _context3.next = 3;
                                    return myStorage.get(item.src);

                                  case 3:
                                    _context3.t0 = _context3.sent;

                                    if (_context3.t0) {
                                      _context3.next = 6;
                                      break;
                                    }

                                    _context3.t0 = item.src;

                                  case 6:
                                    newItem.src = _context3.t0;
                                    qrcodes.push(newItem);

                                  case 8:
                                  case "end":
                                    return _context3.stop();
                                }
                              }
                            }, _callee3);
                          }));

                          return function (_x4) {
                            return _ref6.apply(this, arguments);
                          };
                        }());

                      case 1:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              }));

              return function syncQRCodes() {
                return _ref5.apply(this, arguments);
              };
            }();

            syncImages();
            syncQRCodes(); // modifica struttura image. Per retrocompatibilità.

            if (user.data.medical.images.length && typeof user.data.medical.images[0] === 'string') {
              images_ = user.data.medical.images.map(function (item, i) {
                return {
                  id: Math.random().toString().substr(2, 13),
                  src: item,
                  name: user.data.medical.images_tags[i]
                };
              });
              user.data.medical.images = images_;
            }
            /**
             * Se la pagina è aperta da medical-records, apre in automatico ActionsSheet
             * 
             * @returns {undefined}
             */


            $on("pageAfterIn", function () {
              if ($f7route.query.viewOnMedicalRecords) {
                addItem();
              }
            });
            /**
             * Nasconde il pulsante di rotazione immagine
             * 
             * @param {type} ev
             * @returns {undefined}
             */

            imageError = /*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(ev) {
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return getImage(ev);

                      case 2:
                        ev.target.src = _context5.sent;
                        // 'static/no-image.jpg';
                        $(ev.target).parent().find('i').addClass('hidden');

                      case 4:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));

              return function imageError(_x5) {
                return _ref7.apply(this, arguments);
              };
            }();
            /**
             * Restituisce l'immagine salvata, oppure la url originale se non si trova
             * 
             * @param {type} ev
             * @returns {resolved}
             */


            getImage = /*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(ev) {
                var url, src;
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        url = typeof ev === 'string' ? ev : $(ev.target).data('src');
                        _context6.next = 3;
                        return myStorage.get(url);

                      case 3:
                        _context6.t0 = _context6.sent;

                        if (_context6.t0) {
                          _context6.next = 6;
                          break;
                        }

                        _context6.t0 = url;

                      case 6:
                        src = _context6.t0;
                        return _context6.abrupt("return", src);

                      case 8:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6);
              }));

              return function getImage(_x6) {
                return _ref8.apply(this, arguments);
              };
            }();
            /**
             * Filtra i risultati in base al nome
             * 
             * @param {type} ev
             * @returns {undefined}
             */


            search = function search(ev) {
              var t = ev.target.value;
              if (!t) return clearSearch();
              var reg = new RegExp(t, 'gi');
              user.data.medical.images.forEach(function (e, i) {
                e.name.match(reg) ? $('#img_' + i).parent().removeClass('hidden') : $('#img_' + i).parent().addClass('hidden');
              });
              user.data.medical.documents.forEach(function (e, i) {
                e.name.match(reg) ? $('#doc_' + i).removeClass('hidden') : $('#doc_' + i).addClass('hidden');
              });
              user.data.medical.qrcodes.forEach(function (e, i) {
                e.name.match(reg) ? $('#qrc_' + e.id).parent().removeClass('hidden') : $('#qrc_' + e.id).parent().addClass('hidden');
              });
            };
            /**
             * Ripristina i risultati di ricerca
             * 
             * @returns {undefined}
             */


            clearSearch = function clearSearch() {
              console.log('clearSearch');
              $('.mylist').removeClass('hidden');
            };
            /*
             * Visualizza Action Sheet con le opzioni
             */


            addItem = function addItem() {
              $f7.actions.create({
                buttons: [{
                  label: true,
                  text: lng.documents_select_source,
                  color: 'gray'
                }, {
                  icon: '<i class="icon f7-icons">camera</i>',
                  text: lng.camera,
                  color: 'blue',
                  onClick: addImageFormCamera
                }, {
                  icon: '<i class="icon f7-icons">photo_on_rectangle</i>',
                  text: lng.gallery,
                  color: 'blue',
                  onClick: addImageFromGallery
                }, {
                  icon: '<i class="icon f7-icons">doc_richtext</i>',
                  text: lng.pdf_file,
                  color: 'blue',
                  onClick: addDocument
                }, {
                  icon: '<i class="icon f7-icons">qrcode_viewfinder</i>',
                  text: lng.qrcode,
                  color: 'blue',
                  onClick: scanQRCode
                }, {
                  text: lng.cancel,
                  color: 'red'
                }]
              }).open();
            };
            /**
             * Ruota l'immagine selezionata
             * 
             * @param {type} ev
             * @returns {undefined}
             */


            rotateImage = /*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(ev) {
                var idx, img, newImage, b64;
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        idx = $(ev.target).data('index');
                        img = user.data.medical.images[idx].src;

                        if (img) {
                          _context7.next = 4;
                          break;
                        }

                        return _context7.abrupt("return");

                      case 4:
                        _context7.prev = 4;
                        $f7.preloader.show();
                        _context7.next = 8;
                        return myApp.server.putJSON('image/rotate', {
                          src: img
                        });

                      case 8:
                        newImage = _context7.sent;
                        user.data.medical.images[idx].src = newImage.src;
                        _context7.next = 12;
                        return myApp.server.putJSON('user/me/medical?children=' + (myApp.children || ''), user.data.medical);

                      case 12:
                        user.data.medical = _context7.sent;

                        if (!myApp.children) {
                          _context7.next = 18;
                          break;
                        }

                        _context7.next = 16;
                        return myApp.setChildren(user);

                      case 16:
                        _context7.next = 20;
                        break;

                      case 18:
                        _context7.next = 20;
                        return myApp.user(user);

                      case 20:
                        $update();
                        _context7.next = 23;
                        return $f7.fetchImage(newImage.src);

                      case 23:
                        b64 = _context7.sent;

                        if (!b64) {
                          _context7.next = 29;
                          break;
                        }

                        _context7.next = 27;
                        return myStorage.set(newImage.src, b64);

                      case 27:
                        _context7.next = 29;
                        return myStorage.deleteItem(img);

                      case 29:
                        _context7.next = 34;
                        break;

                      case 31:
                        _context7.prev = 31;
                        _context7.t0 = _context7["catch"](4);
                        $f7.alertError(_context7.t0);

                      case 34:
                        _context7.prev = 34;
                        $f7.preloader.hide();
                        return _context7.finish(34);

                      case 37:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7, null, [[4, 31, 34, 37]]);
              }));

              return function rotateImage(_x7) {
                return _ref9.apply(this, arguments);
              };
            }();
            /*
             * Aggiunge immagine da fotocamera
             */


            addImageFormCamera = /*#__PURE__*/function () {
              var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                var img;
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        console.log('addImageFromCamera');

                        if (!$f7.device.cordova) {
                          _context8.next = 14;
                          break;
                        }

                        _context8.prev = 2;
                        _context8.next = 5;
                        return myApp.cordova.camera();

                      case 5:
                        img = _context8.sent;
                        addImage(img);
                        _context8.next = 12;
                        break;

                      case 9:
                        _context8.prev = 9;
                        _context8.t0 = _context8["catch"](2);
                        console.log(_context8.t0, 'Camera error');

                      case 12:
                        _context8.next = 15;
                        break;

                      case 14:
                        addImageFromGallery(); // $f7.popup.open('.popup-camera');

                      case 15:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8, null, [[2, 9]]);
              }));

              return function addImageFormCamera() {
                return _ref10.apply(this, arguments);
              };
            }();
            /*
             * Camera for webapp
             */


            showCamera = /*#__PURE__*/function () {
              var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        video = document.querySelector("#video");
                        canvas = document.querySelector("#canvas");
                        _context9.next = 4;
                        return navigator.mediaDevices.getUserMedia({
                          video: {
                            facingMode: "environment"
                          },
                          audio: false
                        });

                      case 4:
                        stream = _context9.sent;
                        video.srcObject = stream;

                      case 6:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9);
              }));

              return function showCamera() {
                return _ref11.apply(this, arguments);
              };
            }();

            saveCamera = /*#__PURE__*/function () {
              var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
                var image_data_url;
                return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        console.log(canvas.width, canvas.height);
                        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
                        image_data_url = canvas.toDataURL('image/jpeg');
                        $f7.popup.close();
                        /*
                         $f7.preloader.show()
                         try {
                         let text = await myApp.server.postJSON('qrcodeScanner', {src:image_data_url});
                         } catch(err) {
                         return $f7.dialog.alert(lng.error_message +  '<br> Impossibile leggere il qrcode. ');
                         
                         } finally {
                         $f7.preloader.hide();
                         }
                         addQRCode(text);
                         */

                        addImage(image_data_url);

                      case 5:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, _callee10);
              }));

              return function saveCamera() {
                return _ref12.apply(this, arguments);
              };
            }();

            stopCamera = function stopCamera() {
              stream.getTracks().forEach(function (track) {
                if (track.readyState == 'live') {
                  track.stop();
                }
              });
            };
            /*
             * Aggiunge immagine da Gallery
             */


            addImageFromGallery = /*#__PURE__*/function () {
              var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
                var img, fileInput, openFileDialog;
                return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                  while (1) {
                    switch (_context11.prev = _context11.next) {
                      case 0:
                        console.log('addImageFromGallery');

                        if (!$f7.device.cordova) {
                          _context11.next = 14;
                          break;
                        }

                        _context11.prev = 2;
                        _context11.next = 5;
                        return myApp.cordova.camera({
                          gallery: true
                        });

                      case 5:
                        img = _context11.sent;
                        addImage(img);
                        _context11.next = 12;
                        break;

                      case 9:
                        _context11.prev = 9;
                        _context11.t0 = _context11["catch"](2);
                        console.log(_context11.t0, 'Camera error');

                      case 12:
                        _context11.next = 18;
                        break;

                      case 14:
                        fileInput = document.getElementById('fileDialogId');

                        openFileDialog = function openFileDialog() {
                          return fileInput.click();
                        };

                        fileInput.onchange = function (ev) {
                          var file = ev.target.files[0];
                          var reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = function () {
                            var img = reader.result;
                            addImage(img);
                          };

                          reader.onerror = function (error) {
                            console.log('Error: ', error);
                          };
                        };

                        openFileDialog();

                      case 18:
                      case "end":
                        return _context11.stop();
                    }
                  }
                }, _callee11, null, [[2, 9]]);
              }));

              return function addImageFromGallery() {
                return _ref13.apply(this, arguments);
              };
            }();
            /*
             * Aggiunge immagine da Camera
             * 
             * @param {type} img
             * @returns {undefined}
             */


            addImage = /*#__PURE__*/function () {
              var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(img) {
                var api, api_data, index;
                return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        $f7.preloader.show();
                        _context12.prev = 1;
                        api = 'user/me/medical/images?children=' + (myApp.children || ''), api_data = {
                          src: img,
                          viewOnMedicalRecords: $f7route.query.viewOnMedicalRecords === 'yes'
                        };
                        _context12.next = 5;
                        return myApp.server.putJSON(api, api_data);

                      case 5:
                        user.data.medical.images = _context12.sent;

                        if (!myApp.children) {
                          _context12.next = 11;
                          break;
                        }

                        _context12.next = 9;
                        return myApp.setChildren(user);

                      case 9:
                        _context12.next = 13;
                        break;

                      case 11:
                        _context12.next = 13;
                        return myApp.user(user);

                      case 13:
                        _context12.next = 15;
                        return $update();

                      case 15:
                        index = user.data.medical.images.length - 1;
                        $('#img_' + index).click();
                        console.log(index); //await myStorage.set(user.data.medical.images[index].src, img);

                        syncImages();
                        _context12.next = 24;
                        break;

                      case 21:
                        _context12.prev = 21;
                        _context12.t0 = _context12["catch"](1);
                        $f7.alertError(_context12.t0);

                      case 24:
                        _context12.prev = 24;
                        $f7.preloader.hide();
                        return _context12.finish(24);

                      case 27:
                      case "end":
                        return _context12.stop();
                    }
                  }
                }, _callee12, null, [[1, 21, 24, 27]]);
              }));

              return function addImage(_x8) {
                return _ref14.apply(this, arguments);
              };
            }();
            /**
             * Aggiunge tag all'immagine
             * 
             * @param {type} index
             * @returns {undefined}
             */


            addTag = function addTag(index) {
              var tag = user.data.medical.images[index].name || '';
              $f7.dialog.prompt(lng.rename, /*#__PURE__*/function () {
                var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(text) {
                  return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                      switch (_context13.prev = _context13.next) {
                        case 0:
                          $f7.preloader.show();
                          _context13.prev = 1;
                          user.data.medical.images[index].name = text;
                          _context13.next = 5;
                          return myApp.server.putJSON('user/me/medical?children=' + (myApp.children || ''), user.data.medical);

                        case 5:
                          user.data.medical = _context13.sent;

                          if (!myApp.children) {
                            _context13.next = 11;
                            break;
                          }

                          _context13.next = 9;
                          return myApp.setChildren(user);

                        case 9:
                          _context13.next = 13;
                          break;

                        case 11:
                          _context13.next = 13;
                          return myApp.user(user);

                        case 13:
                          $update();
                          _context13.next = 19;
                          break;

                        case 16:
                          _context13.prev = 16;
                          _context13.t0 = _context13["catch"](1);
                          $f7.alertError(_context13.t0);

                        case 19:
                          _context13.prev = 19;
                          $f7.preloader.hide();
                          return _context13.finish(19);

                        case 22:
                        case "end":
                          return _context13.stop();
                      }
                    }
                  }, _callee13, null, [[1, 16, 19, 22]]);
                }));

                return function (_x9) {
                  return _ref15.apply(this, arguments);
                };
              }(), false, tag);
            };
            /*
             * Aggiunge PDF
             * Usa: cordova-plugin-chooser
             * https://www.npmjs.com/package/cordova-plugin-chooser
             * 
             * Weabapp: usa getFileBrowser() 
             * funzione interna
             */


            addDocument = /*#__PURE__*/function () {
              var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
                var file;
                return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                  while (1) {
                    switch (_context14.prev = _context14.next) {
                      case 0:
                        if (!$f7.device.cordova) {
                          _context14.next = 6;
                          break;
                        }

                        _context14.next = 3;
                        return chooser.getFile('application/pdf');

                      case 3:
                        file = _context14.sent;
                        _context14.next = 9;
                        break;

                      case 6:
                        _context14.next = 8;
                        return getFileBrowser();

                      case 8:
                        file = _context14.sent;

                      case 9:
                        if (file) {
                          _context14.next = 11;
                          break;
                        }

                        return _context14.abrupt("return");

                      case 11:
                        _context14.prev = 11;
                        $f7.preloader.show();
                        _context14.next = 15;
                        return myApp.server.putJSON('user/me/document?children=' + (myApp.children || ''), {
                          data: file.dataURI,
                          name: file.name,
                          viewOnMedicalRecords: $f7route.query.viewOnMedicalRecords === 'yes'
                        });

                      case 15:
                        user.data.medical.documents = _context14.sent;

                        if (!myApp.children) {
                          _context14.next = 21;
                          break;
                        }

                        _context14.next = 19;
                        return myApp.setChildren(user);

                      case 19:
                        _context14.next = 23;
                        break;

                      case 21:
                        _context14.next = 23;
                        return myApp.user(user);

                      case 23:
                        $update();
                        clickOnDocument({
                          index: user.data.medical.documents.length - 1
                        });
                        _context14.next = 30;
                        break;

                      case 27:
                        _context14.prev = 27;
                        _context14.t0 = _context14["catch"](11);
                        $f7.alertError(_context14.t0);

                      case 30:
                        _context14.prev = 30;
                        $f7.preloader.hide();
                        return _context14.finish(30);

                      case 33:
                      case "end":
                        return _context14.stop();
                    }
                  }
                }, _callee14, null, [[11, 27, 30, 33]]);
              }));

              return function addDocument() {
                return _ref16.apply(this, arguments);
              };
            }();
            /**
             * Apre file dialog e ritorna il file selezionato
             * @returns {Promise}
             */


            getFileBrowser = /*#__PURE__*/function () {
              var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
                return _regeneratorRuntime.wrap(function _callee15$(_context15) {
                  while (1) {
                    switch (_context15.prev = _context15.next) {
                      case 0:
                        return _context15.abrupt("return", new Promise(function (resolve, reject) {
                          var fileInput = document.getElementById('filePDF');

                          var openFileDialog = function openFileDialog() {
                            return fileInput.click();
                          };

                          fileInput.onchange = function (ev) {
                            var file = ev.target.files[0];
                            var reader = new FileReader();
                            reader.readAsDataURL(file);

                            reader.onload = function () {
                              var f = {
                                dataURI: reader.result,
                                name: file.name
                              };
                              resolve(f);
                            };

                            reader.onerror = function (error) {
                              console.log('Error: ', error);
                              reject(error);
                            };
                          };

                          openFileDialog();
                        }));

                      case 1:
                      case "end":
                        return _context15.stop();
                    }
                  }
                }, _callee15);
              }));

              return function getFileBrowser() {
                return _ref17.apply(this, arguments);
              };
            }();

            addQRCode = /*#__PURE__*/function () {
              var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(text) {
                var qrcode, data, index, src, b64;
                return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                  while (1) {
                    switch (_context16.prev = _context16.next) {
                      case 0:
                        $f7.preloader.show();
                        _context16.prev = 1;
                        qrcode = {
                          id: Date.now(),
                          name: '',
                          viewOnMedicalRecords: $f7route.query.viewOnMedicalRecords === 'yes',
                          text: text
                        };
                        _context16.next = 5;
                        return myApp.server.postJSON('user/me/medical/qrcodes?children=' + (myApp.children || ''), qrcode);

                      case 5:
                        data = _context16.sent;
                        user.data.medical.qrcodes = data;

                        if (!myApp.children) {
                          _context16.next = 12;
                          break;
                        }

                        _context16.next = 10;
                        return myApp.setChildren(user);

                      case 10:
                        _context16.next = 14;
                        break;

                      case 12:
                        _context16.next = 14;
                        return myApp.user(user);

                      case 14:
                        _context16.next = 16;
                        return $update();

                      case 16:
                        $f7.preloader.hide();
                        index = user.data.medical.qrcodes.length - 1;
                        _context16.next = 20;
                        return renameQRCode(index);

                      case 20:
                        _context16.next = 22;
                        return $update();

                      case 22:
                        $('#qrc_' + qrcode.id).click();
                        src = data[index].src;
                        _context16.next = 26;
                        return $f7.fetchImage(src);

                      case 26:
                        b64 = _context16.sent;

                        if (!b64) {
                          _context16.next = 30;
                          break;
                        }

                        _context16.next = 30;
                        return myStorage.set(src, b64);

                      case 30:
                        syncQRCodes();
                        _context16.next = 36;
                        break;

                      case 33:
                        _context16.prev = 33;
                        _context16.t0 = _context16["catch"](1);
                        $f7.alertError(_context16.t0);

                      case 36:
                        _context16.prev = 36;
                        $f7.preloader.hide();
                        return _context16.finish(36);

                      case 39:
                      case "end":
                        return _context16.stop();
                    }
                  }
                }, _callee16, null, [[1, 33, 36, 39]]);
              }));

              return function addQRCode(_x10) {
                return _ref18.apply(this, arguments);
              };
            }();
            /**
             * Scar QR Code ed importa immagine
             * 
             * @returns {unresolved}
             */


            scanQRCode = function scanQRCode() {
              if (!$f7.device.cordova) {
                $f7.pwaQrcodeScanner().then(function (result) {
                  if (result) addQRCode(result.text);
                });
                return;
              }

              cordova.plugins.barcodeScanner.scan( /*#__PURE__*/function () {
                var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(result) {
                  return _regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                      switch (_context17.prev = _context17.next) {
                        case 0:
                          if (!(result.canceled || !result.text)) {
                            _context17.next = 2;
                            break;
                          }

                          return _context17.abrupt("return");

                        case 2:
                          addQRCode(result.text);

                        case 3:
                        case "end":
                          return _context17.stop();
                      }
                    }
                  }, _callee17);
                }));

                return function (_x11) {
                  return _ref19.apply(this, arguments);
                };
              }(), function (error) {
                console.log("Scanning failed: " + error);
              }, {
                preferFrontCamera: false,
                // iOS and Android
                showFlipCameraButton: true,
                // iOS and Android
                showTorchButton: true,
                // iOS and Android
                torchOn: false,
                // Android, launch with the torch switched on (if available)
                saveHistory: false,
                // Android, save scan history (default false)
                prompt: lng.qrscan_prompt,
                // Android
                resultDisplayDuration: 500,
                // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
                formats: "QR_CODE,PDF_417",
                // default: all but PDF_417 and RSS_EXPANDED
                //orientation: "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
                disableAnimations: false,
                // iOS
                disableSuccessBeep: false // iOS and Android

              });
            };
            /**
             * Prompt 
             * 
             * @param {type} name
             * @returns {Promise}
             */


            myPrompt = /*#__PURE__*/function () {
              var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(name) {
                return _regeneratorRuntime.wrap(function _callee18$(_context18) {
                  while (1) {
                    switch (_context18.prev = _context18.next) {
                      case 0:
                        return _context18.abrupt("return", new Promise(function (resolve, reject) {
                          $f7.dialog.prompt(lng.insert_name, function (value) {
                            resolve(value);
                          }, function () {
                            return resolve(name || '');
                          }, name);
                        }));

                      case 1:
                      case "end":
                        return _context18.stop();
                    }
                  }
                }, _callee18);
              }));

              return function myPrompt(_x12) {
                return _ref20.apply(this, arguments);
              };
            }();
            /**
             * Opzioni QR Code
             * 
             * @param {type} ev
             * @returns {undefined}
             */


            clickOnQRCode = function clickOnQRCode(ev) {
              $f7.actions.create({
                buttons: [{
                  label: true,
                  text: lng.select_action,
                  color: 'gray'
                }, {
                  icon: '<i class="icon f7-icons">photo_on_rectangle</i>',
                  text: lng.show,
                  color: 'blue',
                  onClick: function onClick() {
                    // Visualizza tramite Photo Browser
                    $f7.photoBrowser.create({
                      photos: user.data.medical.qrcodes.map(function (item) {
                        return {
                          url: item.src,
                          caption: item.name
                        };
                      }),
                      swipeToClose: true
                    }).open($(ev.target).data('index') * 1);
                  }
                }, {
                  icon: '<i class="icon f7-icons">pencil_ellipsis_rectangle</i>',
                  text: lng.rename,
                  color: 'blue',
                  onClick: function onClick() {
                    return renameQRCode($(ev.target).data('index'));
                  }
                }, {
                  icon: user.data.medical.qrcodes[$(ev.target).data('index') * 1].viewOnMedicalRecords ? '<i class="f7-icons">eye_slash</i>' : '<i class="f7-icons">eye</i>',
                  text: user.data.medical.qrcodes[$(ev.target).data('index') * 1].viewOnMedicalRecords ? lng.hide_in_medical_records : lng.show_in_medical_records,
                  color: 'blue',
                  onClick: function onClick() {
                    return toggleMedicalRecords(user.data.medical.qrcodes[$(ev.target).data('index') * 1], 'qrcodes');
                  }
                }, {
                  icon: '<i class="icon f7-icons">square_arrow_up_on_square</i>',
                  text: lng.share,
                  color: 'blue',
                  onClick: function onClick() {
                    return share(user.data.medical.qrcodes[$(ev.target).data('index') * 1]);
                  }
                }, {
                  icon: '<i class="icon f7-icons">trash</i>',
                  text: lng.delete,
                  color: 'red',
                  onClick: function onClick() {
                    // Elimina immagine
                    $f7.dialog.confirm(lng.delete_qr_message, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
                      var idx, resp;
                      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
                        while (1) {
                          switch (_context19.prev = _context19.next) {
                            case 0:
                              idx = $(ev.target).data('index');
                              $f7.preloader.show();
                              _context19.prev = 2;
                              _context19.next = 5;
                              return myApp.server.deleteJSON('user/me/medical/qrcodes/' + idx + '?children=' + (myApp.children || ''));

                            case 5:
                              resp = _context19.sent;
                              user.data.medical.qrcodes = resp;

                              if (!myApp.children) {
                                _context19.next = 12;
                                break;
                              }

                              _context19.next = 10;
                              return myApp.setChildren(user);

                            case 10:
                              _context19.next = 14;
                              break;

                            case 12:
                              _context19.next = 14;
                              return myApp.user(user);

                            case 14:
                              $update();
                              _context19.next = 20;
                              break;

                            case 17:
                              _context19.prev = 17;
                              _context19.t0 = _context19["catch"](2);
                              $f7.alertError(_context19.t0);

                            case 20:
                              _context19.prev = 20;
                              $f7.preloader.hide();
                              return _context19.finish(20);

                            case 23:
                            case "end":
                              return _context19.stop();
                          }
                        }
                      }, _callee19, null, [[2, 17, 20, 23]]);
                    })));
                  }
                }, {
                  text: lng.cancel,
                  color: 'gray'
                }]
              }).open();
            };
            /**
             * Imposta visibilità del documento nella cartella medica
             * 
             * @param {type} document
             * @returns {undefined}
             */


            toggleMedicalRecords = /*#__PURE__*/function () {
              var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(document) {
                return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                  while (1) {
                    switch (_context20.prev = _context20.next) {
                      case 0:
                        document.viewOnMedicalRecords = !document.viewOnMedicalRecords;
                        _context20.prev = 1;
                        $f7.preloader.show();
                        _context20.next = 5;
                        return myApp.server.putJSON('user/me/medical?children=' + (myApp.children || ''), user.data.medical);

                      case 5:
                        user.data.medical = _context20.sent;

                        if (!myApp.children) {
                          _context20.next = 11;
                          break;
                        }

                        _context20.next = 9;
                        return myApp.setChildren(user);

                      case 9:
                        _context20.next = 13;
                        break;

                      case 11:
                        _context20.next = 13;
                        return myApp.user(user);

                      case 13:
                        $update();
                        _context20.next = 20;
                        break;

                      case 16:
                        _context20.prev = 16;
                        _context20.t0 = _context20["catch"](1);
                        document.viewOnMedicalRecords = !document.viewOnMedicalRecords;
                        $f7.alertError(_context20.t0);

                      case 20:
                        _context20.prev = 20;
                        $f7.preloader.hide();
                        return _context20.finish(20);

                      case 23:
                      case "end":
                        return _context20.stop();
                    }
                  }
                }, _callee20, null, [[1, 16, 20, 23]]);
              }));

              return function toggleMedicalRecords(_x13) {
                return _ref22.apply(this, arguments);
              };
            }();
            /**
             * Usa cordova-plugin-x-socialsharing
             * https://www.npmjs.com/package/cordova-plugin-x-socialsharing
             * 
             * @param {type} document 
             * @returns {undefined}
             */


            share = function share(document) {
              var message = user.data.lastname + ', ' + user.data.name + '\r\n' + (document.name || '') + '\r\n' + (document.text || '') + '\r\n' + document.src;
              var files = [document.src];
              var w = window.innerWidth;
              $f7.actions.create({
                buttons: [{
                  label: true,
                  text: lng.select_app,
                  color: 'gray'
                }, {
                  icon: '<i class="f7-icons">at</i>',
                  text: lng.share_via_email,
                  color: 'blue',
                  onClick: function onClick() {
                    if (!$f7.device.cordova) return $f7.webShareViaEmail(lng.share_document, message);
                    window.plugins.socialsharing.canShareViaEmail(function () {
                      window.plugins.socialsharing.shareViaEmail(message, // can contain HTML tags, but support on Android is rather limited:  http://stackoverflow.com/questions/15136480/how-to-send-html-content-with-image-through-android-default-email-client
                      lng.share_document, null, // TO: must be null or an array
                      null, // CC: must be null or an array
                      null, // BCC: must be null or an array
                      files, // FILES: can be null, a string, or an array
                      function (onSuccess) {
                        // called when sharing worked, but also when the user cancelled sharing via email. 
                        // On iOS, the callbacks' boolean result parameter is true when sharing worked, false if cancelled. 
                        // On Android, this parameter is always true so it can't be used. 
                        console.log('Share via email success');
                        if ($f7.device.ios && w !== window.innerWidth) window.location.reload();
                      }, function (onError) {
                        // called when sh*t hits the fan
                        $f7.dialog.alert(lng.error_message + '<br/>' + onError, function () {
                          if ($f7.device.ios && w !== window.innerWidth) window.location.reload();
                        });
                      });
                    }, function () {
                      window.plugins.socialsharing.shareWithOptions({
                        message: message,
                        chooserTitle: lng.select_app
                      }, function () {
                        if (w !== window.innerWidth) window.location.reload();
                      }, function () {
                        if (w !== window.innerWidth) window.location.reload();
                      });
                    });
                  }
                }, {
                  icon: '<i class="f7-icons">chat_bubble_text</i>',
                  text: lng.share_via_wa,
                  color: 'blue',
                  onClick: function onClick() {
                    shareViaWA(message);
                  }
                }, {
                  icon: '',
                  text: lng.cancel,
                  color: 'gray'
                }]
              }).open();
            };
            /**
             * Avvia condivisione tramite WA
             * @param {type} msg
             * @returns {undefined}
             */


            shareViaWA1 = function shareViaWA1(msg) {
              var w = window.innerWidth;
              window.plugins.socialsharing.shareViaWhatsApp(msg, null, null, function (success) {
                if (w !== window.innerWidth) window.location.reload();
              }, function (errormsg) {
                return $f7.dialog.alert(lng.error_message + '<br/>' + errormsg);
              }, function () {
                if ($f7.device.ios && w !== window.innerWidth) window.location.reload();
              });
            };
            /**
             * Controlla la fattibilità di condividere con WA.
             * Chiede i permessi, se non impostati
             * Se possibile, avvia la condivisione
             * 
             * @param {type} msg
             * @returns {undefined}
             */


            shareViaWA = function shareViaWA(msg) {
              if (!$f7.device.cordova) return $f7.webShareViaWA(msg);
              var w = window.innerWidth;
              window.plugins.socialsharing.canShareVia('whatsapp', 'msg', null, null, null, shareViaWA1, function (e) {
                // patch -> dimensione window non ripristinata dal plugin
                // effettua il reload dell'app per ripristinare la dimensione della finestra
                // al momento non si trova altra soluzione ...
                window.plugins.socialsharing.shareWithOptions({
                  message: msg,
                  chooserTitle: lng.select_app
                }, function () {
                  if (w !== window.innerWidth) window.location.reload();
                }, function () {
                  if (w !== window.innerWidth) window.location.reload();
                });
              });
            };

            renameQRCode = /*#__PURE__*/function () {
              var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(index) {
                var oldname, name;
                return _regeneratorRuntime.wrap(function _callee21$(_context21) {
                  while (1) {
                    switch (_context21.prev = _context21.next) {
                      case 0:
                        oldname = user.data.medical.qrcodes[index].name || '';
                        _context21.next = 3;
                        return myPrompt(oldname);

                      case 3:
                        name = _context21.sent;
                        user.data.medical.qrcodes[index].name = name;
                        _context21.next = 7;
                        return myApp.server.putJSON('user/me/medical/qrcodes?children=' + (myApp.children || ''), user.data.medical.qrcodes);

                      case 7:
                        user.data.medical.qrcodes = _context21.sent;

                        if (!myApp.children) {
                          _context21.next = 13;
                          break;
                        }

                        _context21.next = 11;
                        return myApp.setChildren(user);

                      case 11:
                        _context21.next = 15;
                        break;

                      case 13:
                        _context21.next = 15;
                        return myApp.user(user);

                      case 15:
                        _context21.next = 17;
                        return $update();

                      case 17:
                        return _context21.abrupt("return", user.data.medical.qrcodes);

                      case 18:
                      case "end":
                        return _context21.stop();
                    }
                  }
                }, _callee21);
              }));

              return function renameQRCode(_x14) {
                return _ref23.apply(this, arguments);
              };
            }();
            /*
             * Apre Action Sheet con opzioni:
             *  - Visualizza -> apre Photo Browser
             *  - Condividi  -> apre condivisione tramite Social
             *  - Elimina    -> elimina previa conferma dell'utente
             */


            clickOnPhoto = function clickOnPhoto(ev) {
              var idx = $(ev.target).data('index') * 1;
              $f7.actions.create({
                buttons: [{
                  label: true,
                  text: lng.select_action,
                  color: 'gray'
                }, {
                  icon: '<i class="icon f7-icons">photo_on_rectangle</i>',
                  text: lng.show,
                  color: 'blue',
                  onClick: function onClick() {
                    // Visualizza tramite Photo Browser
                    $f7.photoBrowser.create({
                      photos: user.data.medical.images.map(function (item) {
                        return {
                          url: item.src,
                          caption: item.name
                        };
                      }),
                      swipeToClose: true
                    }).open(idx);
                  }
                }, {
                  icon: '<i class="icon f7-icons">number</i>',
                  text: lng.rename,
                  color: 'blue',
                  onClick: function onClick() {
                    return addTag(idx);
                  }
                }, {
                  icon: user.data.medical.images[idx].viewOnMedicalRecords ? '<i class="f7-icons">eye_slash</i>' : '<i class="f7-icons">eye</i>',
                  text: user.data.medical.images[idx].viewOnMedicalRecords ? lng.hide_in_medical_records : lng.show_in_medical_records,
                  color: 'blue',
                  onClick: function onClick() {
                    return toggleMedicalRecords(user.data.medical.images[idx], 'images');
                  }
                }, {
                  icon: '<i class="icon f7-icons">square_arrow_up_on_square</i>',
                  text: lng.share,
                  color: 'blue',
                  onClick: function onClick() {
                    // condividi tramite social
                    if ($f7.device.cordova && $f7.device.android) {
                      var options = {
                        message: '',
                        subject: lng.share_image,
                        files: [user.data.medical.images[idx].src],
                        url: '',
                        chooserTitle: lng.select_app
                      };

                      var onSuccess = function onSuccess(result) {// ...
                      };

                      var onError = function onError(msg) {
                        console.log("Sharing failed with message: " + msg);
                        if ($f7.device.ios) window.location.reload();
                      };

                      window.plugins.socialsharing.shareWithOptions(options, onSuccess, onError);
                    } else {
                      share(user.data.medical.images[idx]);
                    }
                  }
                }, {
                  icon: '<i class="icon f7-icons">trash</i>',
                  text: lng.delete,
                  color: 'red',
                  onClick: function onClick() {
                    // Elimina immagine
                    $f7.dialog.confirm(lng.delete_image_message, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
                      var idx;
                      return _regeneratorRuntime.wrap(function _callee22$(_context22) {
                        while (1) {
                          switch (_context22.prev = _context22.next) {
                            case 0:
                              idx = $(ev.target).data('index') * 1;
                              user.data.medical.images.splice(idx, 1);
                              console.log(user.data.medical.images);
                              $f7.preloader.show();
                              _context22.prev = 4;
                              _context22.next = 7;
                              return myApp.server.putJSON('user/me/medical?children=' + (myApp.children || ''), user.data.medical);

                            case 7:
                              user.data.medical = _context22.sent;

                              if (!myApp.children) {
                                _context22.next = 13;
                                break;
                              }

                              _context22.next = 11;
                              return myApp.setChildren(user);

                            case 11:
                              _context22.next = 15;
                              break;

                            case 13:
                              _context22.next = 15;
                              return myApp.user(user);

                            case 15:
                              $update();
                              _context22.next = 21;
                              break;

                            case 18:
                              _context22.prev = 18;
                              _context22.t0 = _context22["catch"](4);
                              $f7.alertError(_context22.t0);

                            case 21:
                              _context22.prev = 21;
                              $f7.preloader.hide();
                              return _context22.finish(21);

                            case 24:
                            case "end":
                              return _context22.stop();
                          }
                        }
                      }, _callee22, null, [[4, 18, 21, 24]]);
                    })));
                  }
                }, {
                  text: 'Annulla',
                  color: 'gray'
                }]
              }).open();
            };
            /*
             * Apre Action Sheet con opzioni:
             *  - Apri       -> apre il tramite InAppBrowser
             *  - Condividi  -> apre condivisione tramite Social
             *  - Elimina    -> elimina previa conferma dell'utente
             */


            clickOnDocument = function clickOnDocument(ev) {
              var idx = ev.target ? $(ev.target).data('index') * 1 : ev.index * 1;
              $f7.actions.create({
                buttons: [{
                  label: true,
                  text: lng.select_action,
                  color: 'gray'
                }, {
                  icon: '<i class="icon f7-icons">doc_richtext</i>',
                  text: lng.open,
                  color: 'blue',
                  onClick: function onClick() {
                    // Apre il file nel browser predefinito del Device
                    var url = user.data.medical.documents[idx].url;
                    myApp.iab(url, '_system');
                  }
                }, {
                  icon: '<i class="icon f7-icons">pencil_ellipsis_rectangle</i>',
                  text: lng.rename,
                  color: 'blue',
                  onClick: function onClick() {
                    $f7.dialog.prompt('Rinomina file', /*#__PURE__*/function () {
                      var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(success) {
                        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
                          while (1) {
                            switch (_context23.prev = _context23.next) {
                              case 0:
                                user.data.medical.documents[idx].name = success + '.pdf';
                                $f7.preloader.show();
                                _context23.prev = 2;
                                _context23.next = 5;
                                return myApp.server.putJSON('user/me/medical/documents/?children=' + (myApp.children || ''), user.data.medical.documents);

                              case 5:
                                if (!myApp.children) {
                                  _context23.next = 10;
                                  break;
                                }

                                _context23.next = 8;
                                return myApp.setChildren(user);

                              case 8:
                                _context23.next = 12;
                                break;

                              case 10:
                                _context23.next = 12;
                                return myApp.user(user);

                              case 12:
                                $update();
                                _context23.next = 18;
                                break;

                              case 15:
                                _context23.prev = 15;
                                _context23.t0 = _context23["catch"](2);
                                $f7.alertError(_context23.t0);

                              case 18:
                                _context23.prev = 18;
                                $f7.preloader.hide();
                                return _context23.finish(18);

                              case 21:
                              case "end":
                                return _context23.stop();
                            }
                          }
                        }, _callee23, null, [[2, 15, 18, 21]]);
                      }));

                      return function (_x15) {
                        return _ref25.apply(this, arguments);
                      };
                    }(), function (cancel) {
                      return console.log(cancel, 'cancel');
                    }, user.data.medical.documents[idx].name.replace(/\.pdf$/i, ''));
                  }
                }, {
                  icon: user.data.medical.documents[idx].viewOnMedicalRecords ? '<i class="f7-icons">eye_slash</i>' : '<i class="f7-icons">eye</i>',
                  text: user.data.medical.documents[idx].viewOnMedicalRecords ? lng.hide_in_medical_records : lng.show_in_medical_records,
                  color: 'blue',
                  onClick: function onClick() {
                    return toggleMedicalRecords(user.data.medical.documents[idx], 'documents');
                  }
                }, {
                  icon: '<i class="icon f7-icons">square_arrow_up_on_square</i>',
                  text: lng.share,
                  color: 'blue',
                  onClick: function onClick() {
                    // condividi tramite social
                    if ($f7.device.cordova && $f7.device.android) {
                      var options = {
                        message: '',
                        subject: lng.share_file,
                        files: [user.data.medical.documents[idx].url],
                        url: user.data.medical.documents[idx].url,
                        chooserTitle: lng.select_app
                      };

                      var onSuccess = function onSuccess(result) {// ..
                      };

                      var onError = function onError(msg) {
                        console.log("Sharing failed with message: " + msg);
                        if ($f7.device.ios) window.location.reload();
                      };

                      window.plugins.socialsharing.shareWithOptions(options, onSuccess, onError);
                    } else {
                      var _document = {
                        name: user.data.medical.documents[idx].name,
                        src: user.data.medical.documents[idx].url
                      };
                      share(_document);
                    }
                  }
                }, {
                  icon: '<i class="icon f7-icons">trash</i>',
                  text: lng.delete,
                  color: 'red',
                  onClick: function onClick() {
                    $f7.dialog.confirm(lng.delete_document_message, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
                      var children, api;
                      return _regeneratorRuntime.wrap(function _callee24$(_context24) {
                        while (1) {
                          switch (_context24.prev = _context24.next) {
                            case 0:
                              $f7.preloader.show();
                              _context24.prev = 1;
                              children = myApp.children || '';
                              api = 'user/me/medical/documents/' + idx + '?children=' + children;
                              _context24.next = 6;
                              return myApp.server.deleteJSON(api);

                            case 6:
                              user.data.medical.documents = _context24.sent;

                              if (!myApp.children) {
                                _context24.next = 12;
                                break;
                              }

                              _context24.next = 10;
                              return myApp.setChildren(user);

                            case 10:
                              _context24.next = 14;
                              break;

                            case 12:
                              _context24.next = 14;
                              return myApp.user(user);

                            case 14:
                              $update();
                              _context24.next = 20;
                              break;

                            case 17:
                              _context24.prev = 17;
                              _context24.t0 = _context24["catch"](1);
                              $f7.alertError(_context24.t0);

                            case 20:
                              _context24.prev = 20;
                              $f7.preloader.hide();
                              return _context24.finish(20);

                            case 23:
                            case "end":
                              return _context24.stop();
                          }
                        }
                      }, _callee24, null, [[1, 17, 20, 23]]);
                    })));
                  }
                }, {
                  text: lng.cancel,
                  color: 'gray'
                }]
              }).open();
            };

            return _context25.abrupt("return", function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="documents">
    <!-- Top Navbar -->
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left">
          <a href="#" class="link back">
            <i class="f7-icons ios-only">arrow_left</i>
            <i class="material-icons md-only">arrow_back</i>
          </a>
        </div>
        <div class="title sliding">
          <div class="display-flex align-items-center">
            <div class="avatar-small margin-left-half" style="background-image: url(${avatar})"></div>
            <div class="padding-left">${user.data.name}</div>
          </div>
        </div>
        <div class="right">
          <a href="#" @click=${addItem} class="link icon-only navbar-tooltip">
            <i class="icon f7-icons if-not-md">plus</i>
            <i class="icon material-icons if-md">add</i>
          </a>
        </div>
        <div class="subnavbar">
          <form class="searchbar">
            <div class="searchbar-inner">
              <div class="searchbar-input-wrap">
                <input @keyup=${search} type="search" placeholder="${lng.search}" />
                <i class="searchbar-icon"></i>
                <span @click=${clearSearch} class="input-clear-button"></span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Scrollable page content-->
    <div class="page-content hide-navbar-on-scroll unselectable">
      ${( 
      (user.data.medical.documents.length || '') || 
      (user.data.medical.images.length || '') || 
      (user.data.medical.qrcodes.length || '')
      ) && $h`
      <div class="bg-color-black text-color-white text-align-center padding-horizontal padding-vertical-half">
        ${lng.documents_plus_message}
      </div>
      `}

      ${(user.data.medical.images.length || '') && $h`
      <h3 class="text-align-center">${lng.photo_archive}</h3>
      `}
      <div class="image-gallery-container">
        ${user.data.medical.images.map((item, index) => $h`
        <div style="position: relative" class="mylist">
          <img src="${item.src}" 
               data-src="${item.src}" 
               id="img_${index}" 
               data-index="${index}" 
               @click=${clickOnPhoto} 
               @error=${imageError} /> 
          <i class="f7-icons text-color-white" 
             style="border-radius: 50%; background-color: rgba(255,0,0,.7); padding: 3px; position: absolute; top:3px; right:3px;" 
             data-index="${index}"
             @click="${rotateImage}">crop_rotate</i>
          <div class="img-tag">${item.name}</div>
        </div>
        `)}
      </div>

      ${(user.data.medical.qrcodes.length || '') && $h`
      <h3 class="text-align-center">${lng.qrcodes_archive}</h3>
      `}
      <div class="image-gallery-container">
        ${user.data.medical.qrcodes.map((item, index) => $h`
        <div style="position: relative" class="mylist">
          <img src="${item.src}" data-src="${item.src}" id="qrc_${
                 item.id
               }" data-index="${index}" @click=${clickOnQRCode}  @error=${imageError} /> 
          <div class="qrcode-name">${item.name || ''}</div>
        </div>
        `)}
      </div>

      ${(user.data.medical.documents.length ||'') && $h`
      <h3 class="text-align-center">${lng.documents_archive}</h3>
      `}
      <div class="documents-container">
        ${user.data.medical.documents.map((item, index) => $h`
        <div class="document mylist" id="doc_${
               index
             }" data-index="${index}" @click=${clickOnDocument}>
          <img data-index="${index}" src="static/pdf-icon.png"/>
          <div data-index="${index}" class="document-caption">${item.name}</div>
        </div>
        `)}
      </div>

      ${((!user.data.medical.documents.length || '') && (!user.data.medical.images.length || '')) && $h`
      <div class="display-flex flex-direction-column justify-content-center align-items-center h-90">
        <img width="150" src="static/notfound.svg"/>
        <h3>${lng.documents_empty_message}</h3>
        <div class="block text-align-center">
          ${lng.documents_empty_info_message} <br/>
          ${lng.documents_plus_message}
        </div>
      </div>
      `}
    </div>

    <div class="popup popup-tablet-fullscreen popup-camera bg-color-black" @popup:opened=${showCamera} @popup:close=${stopCamera}>
      <video id="video" width="${vw}" height="${vh}" style="position: fixed; left:0; top:0; right: 0; bottom:0" autoplay playsinline></video>
      <canvas id="canvas" width="${vw}" height="${vh}"></canvas>
      <div style="position:fixed; bottom:0; left:0; right: 0" class="text-align-center">
        <div class="row">
          <div class="col">
            <a href="#" class="button button-large button-fill color-black popup-close">Annulla</a>
          </div>
          <div class="col">
            <a href="#" class="button button-large button-fill color-secondary" @click=${saveCamera}>OK</a>
          </div>
        </div>
      </div>
    </div>

    <form style="display:none">
      <input type="file" accept="image/*" id="fileDialogId" />
      <input type="file" accept="application/pdf" id="filePDF" />
    </form>

  </div>
`
    }
    );

          case 58:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
})();